<template>
<el-form-item :label="currentField.label" :label-width="currentField.labelWidth + 'px'">
  <el-checkbox-group v-model="checkList">
    <el-checkbox v-for="item in currentField.options" :key="item.optionValue" :label="item.optionLabel" :disabled="item.disabled"
    v-on:change="CheckboxChange">
    </el-checkbox>
  </el-checkbox-group>
</el-form-item>
</template>

<script>
import fetchData from '../api/fetch-data';

export default {
  name: 'Checkbox',
  props: ['currentField'],
  data() {
    return {
      checkList: []
    }
  },
  mounted() {
    if (this.currentField.isFromUrl) {
      let dataUrl = this.currentField.dataUrl;
      let valueField = this.currentField.valueField;
      let labelField = this.currentField.labelField;
      let promise = fetchData.fetchOptionsData(dataUrl, labelField, valueField);
      promise.then((data) => {
        this.currentField.options = data;
      });
    }
    if (this.currentField.componentValue) {
      try {
        this.checkList = JSON.parse(this.currentField.componentValue);
      } catch (error) {
        console.error('Error parsing JSON:', error);
        // Handle the error accordingly, such as setting a default value for this.checkList
        this.checkList = false
      }
    }
  },
  methods: {
      CheckboxChange() {
        this.currentField.componentValue = this.checkList;
      }
    }
}
</script>

<style>
.el-checkbox-group {
  font-size: 14px;
}
.el-checkbox__label{
  white-space: normal;
}
</style>
